










import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Dropdown from '@/components/swine/DropdownAnalysisTemplate.vue';
import { StateStores } from '@/store/swine/states/index';
import { DropdownOption } from '@/models/swine/dropdown.model';
import { State } from '@/models/swine/states/state.model';
import { generateUniqueId } from '@/utils/lodash';
@Component({
  components: {
    Dropdown,
  },
})
export default class StateDropdown extends Vue {
  store = StateStores.list;
  states: DropdownOption[] = [];
  displayValue = 'State/Province';

  @Prop({
    type: Boolean,
    default: true,
  })
  disabled!: boolean;

  @Prop({
    type: String,
    default: null,
  })
  regionId!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  resetDropdown!: boolean;

  mounted() {
    this.createBaseData();
  }

  createBaseData() {
    this.states = [];
    this.states.push({
      text: `State/Province`,
      value: `-1`,
      uniqueKey: generateUniqueId(`state_`),
    });
  }

  @Watch(`disabled`)
  @Watch(`regionId`)
  getData() {
    if (this.regionId && !this.disabled) {
      this.store.getAllStatesByRegionId(this.regionId);
    }
  }

  @Watch(`store.response`)
  getStatesByRegionId() {
    if (this.store.response && this.states) {
      this.states = [];
      this.store.response.map((data: State) => {
        this.states.push({
          text: data.code,
          value: String(data.id),
          uniqueKey: generateUniqueId(`${data.code}_`),
        });
      });
    }
  }

  @Emit(`select`)
  selectState(data: DropdownOption) {
    this.displayValue = data.text;
    return data.value;
  }

  @Watch('resetDropdown', { deep: true })
  resetDropdownOptions() {
    if (this.resetDropdown) {
      this.displayValue = 'State/Province';
      this.resetProcessComplete();
    }
  }

  @Emit('reset')
  resetProcessComplete() {
    return true;
  }
}
